import { Grid, Typography } from "@material-ui/core";
import useText from "constants/text";
import { useValidationDialogStyle } from "domains/CashManagement/style";
import { confirmProps } from "domains/CashManagement/types";
import { Button } from "ui/Button";
import Dialog from "ui/Dialog";

function ValidateDialog({ open, onConfirm, onClose, isConfirm }: confirmProps) {
  const { text } = useText();
  const classes = useValidationDialogStyle();

  const handleOnClose = () => {};

  const handleConfirm = () => {};

  return (
    <div>
      <div>
        <Dialog
          open={open}
          confirmButtonTitle={text.all.confirm}
          cancelButtonTitle={text.all.cancel}
          handleClose={handleOnClose}
          handleConfirm={handleConfirm}
          maxWidth="xs"
          hideDialogHeader
          dialogActionButtonCustomized
          className={classes.dialog}
        >
          <div className={classes.circle}>
            <Typography className={classes.helperIcon}>i</Typography>
          </div>
          <Grid container spacing={5}>
            <Grid item xs={12} className={classes.container}>
              <p className={classes.message}>
                {" "}
                {isConfirm
                  ? text.cash_management.confirm_reception_message
                  : text.cash_management.decline_reception_message}
              </p>
              <Button
                variant="contained"
                onClick={onConfirm}
                color="primary"
                className={classes.yesButton}
                size="large"
              >
                {text.all.yes}
              </Button>
              <Button variant="contained" onClick={onClose} className={classes.cancelButton} size="large">
                {text.all.cancel}
              </Button>
            </Grid>
          </Grid>
        </Dialog>
      </div>
    </div>
  );
}

export default ValidateDialog;
